import { useState, useEffect } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  notification,
  Select,
  Space,
} from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { get, post, put } from "../../../services";

const EventForm = () => {
  const { id } = useParams(); // This will get the 'id' from the URL
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [adminData, setAdmins] = useState([]);
  // notification handler
  const openNotification = (message, description) => {
    notification.open({
      message: message,
      description: description,
    });
  };
  let options = [];
  // Method for API call
  const getAdmins = () => {
    get(`/user/getAllUsers?page=${1}&limit=${100}`)
      .then((response) => {
        console.log(response?.data?.users);
        response?.data?.users?.map((item) => {
          options.push({
            value: item?._id,
            label: item?.name,
          });
        });
        setAdmins(options);
        setLoader(false);
      })
      .catch((err) => {
        // to check token if token expired then logout user
        setLoader(false);
      });
  };

  // useEffect to get content
  useEffect(() => {
    getAdmins();
  }, []);

  // onFinish handler
  const onFinish = (values) => {
    // setLoader(true);
    const payload = {
      deductions: values?.deductions,
      baseSalary: values?.baseSalary,
      allowances: values?.allowances,
      startDate: values?.startDate?.$d,
      endDate: values?.endDate?.$d,
    };
    post(`/hr/salary/${values?.assignedUser}`, payload)
      .then(() => {
        setLoader(false);
        navigate("/salary-details");
        openNotification("Success", "Salary Added For Employee");
      })
      .catch((error) => {
        setLoader(false);
        openNotification("Error", error?.response?.data?.message);
      });
  };

  return (
    <>
      <div className="header">
        <h3>Add Employee Salary</h3>
      </div>
      <div className="form_container">
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="baseSalary"
            label="Base Salary"
            rules={[
              { required: true, message: "Please enter your Base Salary" },
            ]}
          >
            <Input type="number" />
          </Form.Item>
          <Form.Item
            name="allowances"
            label="Allowances"
            rules={[
              { required: true, message: "Please enter your allowances" },
            ]}
          >
            <Input type="number" />
          </Form.Item>
          <Form.Item
            name="deductions"
            label="Deductions"
            rules={[{ required: true, message: "Please enter deductions" }]}
          >
            <Input type="number" />
          </Form.Item>
          <Form.Item
            className="w-full"
            name="assignedUser"
            direction="vertical"
            label="Add Employee"
            rules={[{ required: true, message: "Please select employee" }]}
          >
            <Select
              name="assignedUsers"
              allowClear
              style={{ width: "100%" }}
              placeholder="Please Select Employe"
              options={adminData}
            />
          </Form.Item>
          <Form.Item
            name="startDate"
            label="Start Date"
            rules={[
              { required: true, message: "Please enter your Start Date" },
            ]}
            className="w-full"
          >
            <DatePicker className="w-full" />
          </Form.Item>
          <Form.Item
            name="endDate"
            label="End Date"
            rules={[{ required: true, message: "Please enter your End Date" }]}
            className="w-full"
          >
            <DatePicker className="w-full" />
          </Form.Item>
          <Form.Item>
            <div className="form_submit">
              <Button
                className="back_button"
                onClick={() => navigate("/admins")}
              >
                Back
              </Button>
              <Button htmlType="submit">{loader ? "wait..." : "Save"}</Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </>
  );
};
export default EventForm;
